export enum OrgStatus {
  CR = 1,
  NOTSTARTED,
  CFO,
  DIR,
  LP,
  LR,
  FINAL,
  DRAFT,
  RR,
  RETURNED,
  NOTREQUIRED,
}

//Returns Form status as string.
//Form status not same transformation as Role Transformation
export function getFormStatusAsTitle(formStatus: number): string {
  switch (formStatus) {
    case OrgStatus.CR: return 'CR';
    case OrgStatus.NOTSTARTED: return 'NOT STARTED';
    case OrgStatus.CFO: return 'CFO';
    case OrgStatus.DIR: return 'DIR';
    case OrgStatus.LP: return 'LP';
    case OrgStatus.LR: return 'LR';
    case OrgStatus.FINAL: return 'FINAL';
    case OrgStatus.DRAFT: return 'DRAFT';
    case OrgStatus.RR: return 'RR';
    case OrgStatus.RETURNED: return 'RETURNED';
    case OrgStatus.NOTREQUIRED: return 'NOT REQUIRED';
    default: return '';
  }
}

/**
 * Obtains the order in which forms are approved based on their matching database value (enumerated as OrgStatus).
 * The intent of this function is to give a logical numeric state that corresponds with the role to resoponsibility based comparisons.
 * The approval order is as follows:
 *    NOTSTARTED/RETURNED/DRAFT (1) -> LP (2) -> LR (3) -> CR (4) -> RR (5) -> CFO (6) -> DIR (7) -> FINAL (8)
 *    The NOTREQUIRED (9) state gets the highest value.
 *    
 * 
 * @param formStatus The OrgStatus enumerated value
 * @returns the numeric approval chain order that forms go through, beginning with NOTSTARTED and ending with NOTREQUIRED.
 */
export function getApprovalOrder(formStatus: number): number {
  switch (formStatus) {
    case OrgStatus.NOTSTARTED: return 1;
    case OrgStatus.RETURNED: return 1;
    case OrgStatus.DRAFT: return 1;
    case OrgStatus.LP: return 2;
    case OrgStatus.LR: return 3;
    case OrgStatus.CR: return 4;
    case OrgStatus.RR: return 5;
    case OrgStatus.CFO: return 6;
    case OrgStatus.DIR: return 7;
    case OrgStatus.FINAL: return 10;
    case OrgStatus.NOTREQUIRED: return 10;
    //no default return on purpose
  }
}
